<template>
  <div class="serback">
    <div class="serback_content">
      非常感谢您对我们此次的配合！
      您所提供的信息对我们今后工作非常有价值，
      我们将会把相关信息进行综合分析，希望我们的调查能对您有所帮助！
    </div>
    <div class="serback_back">
      <button  class="serback_back_btn"  @click="fanhui">返回试卷列表</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Serback',
  mounted () {
    if (!this.$store.state.loginUser) {
      this.$router.replace('/')
    }
  },
  methods: {
    fanhui: function () {
      this.$router.replace('/list')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .serback
    position: absolute
    width: 100%
    height: 100%
    left: 0
    top: 0
    right: 0
    bottom: 0
    background: #00bcd4
    display : flex
    flex-direction : column
    .serback_content
      margin-top: .8rem
      border-radius: .07rem
      margin-left: .2rem
      margin-right: .2rem
      background-color : white
      font-size: .5rem
      line-height : .6rem
      color: #976e48
      text-align : justify
      text-indent : .9rem
      padding : .2rem
    .serback_back
      text-align : center
      margin-top: .3rem
      margin-left: .2rem
      margin-right: .2rem
      .serback_back_btn
        position : relative
        width : 100%
        text-align : center
        background: #AC2925
        font-size : .6rem
        padding-bottom: .03rem
        padding-left: .2rem
        padding-right: .2rem
        border-radius: .1rem
        outline: none
        color: white
        font-weight: bold
</style>



// WEBPACK FOOTER //
// src/servey/serback.vue